import React from 'react';

import {ReviewStatus as ReviewStatusEnum} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ReviewSummaryRLCVersion} from 'notebook/reviews/ReviewConstants';
import * as ReviewUtil from 'notebook/reviews/ReviewUtil';
import getTestProps from 'test/lib/cypress/getTestProps';

interface Review {
  status: ReviewStatusEnum;
  reviewLifecycleVersion?: ReviewSummaryRLCVersion | null;
}

interface ReviewStatusProps {
  review?: Review | null;
}

export default function ReviewStatus({review}: ReviewStatusProps): JSX.Element {
  return (
    <span
      className={`reviewStatus ${ReviewUtil.getStatusCSSClassFromReview(review?.status)}`}
      {...getTestProps({component: 'ReviewStatus', element: 'text'})}
    >
      {ReviewUtil.getStatusTextFromReview(review?.status, review?.reviewLifecycleVersion?.terminalState)}
    </span>
  );
}
